module.exports = __webpack_public_path__ + "o.no2.b554be8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/o.no2.jpg
// module id = MgIx
// module chunks = 0